import { MapPin } from "lucide-react";
import { ADDRESS_DISPLAY, MAPS_URL, NAV_IDS, PHONE_DISPLAY, WHATSAPP_URL, scrollToId } from "@/lib/constants";
import { useLanguage } from "@/lib/i18n";
import WhatsAppIcon from "@/components/WhatsAppIcon";

export default function SiteFooter() {
  const { t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="bg-ink text-linen/80">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-14 grid gap-10 sm:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.svg" alt="Logo Casa Paola Arcore" className="w-9 h-9 rounded-lg" />
            <span className="font-serif text-xl font-semibold text-linen">
              Casa Paola <span className="italic text-terracotta">Arcore</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-linen/60 max-w-xs">
            {t.footer.tagline}
          </p>
        </div>

        <nav aria-label={t.footer.explore}>
          <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-linen/40 font-bold mb-4">
            {t.footer.explore}
          </p>
          <ul className="space-y-2.5">
            {NAV_IDS.map((id) => (
              <li key={id}>
                <button
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollToId(id)}
                  className="text-sm text-linen/70 hover:text-terracotta transition-colors"
                >
                  {t.nav[id]}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-linen/40 font-bold mb-4">
            {t.footer.contacts}
          </p>
          <a
            data-testid="footer-maps-link"
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-linen/70 hover:text-terracotta transition-colors mb-3"
          >
            <MapPin className="w-4 h-4 shrink-0" />
            {ADDRESS_DISPLAY}
          </a>
          <a
            data-testid="footer-whatsapp-link"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-linen/70 hover:text-whatsapp transition-colors"
          >
            <WhatsAppIcon className="w-4 h-4 shrink-0" />
            WhatsApp · {PHONE_DISPLAY}
          </a>
        </div>
      </div>

      <div className="border-t border-linen/10">
        <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-5 flex flex-wrap items-center justify-between gap-3">
          <p className="font-mono-label text-[10px] uppercase tracking-[0.2em] text-linen/40">
            {t.footer.rights}
          </p>
          <p
            data-testid="footer-cin"
            className="font-mono-label text-[10px] uppercase tracking-[0.2em] text-linen/40"
          >
            CIN: IT108004C2NOU4JBYM
          </p>
          <p className="font-mono-label text-[10px] uppercase tracking-[0.2em] text-linen/40">
            {t.footer.specs}
          </p>
        </div>
      </div>
    </footer>
  );
}
